import { Locale } from 'chaika-enums';
export const teethConditions = {
    crown: {
        [Locale.Ru]: 'Коронка',
        [Locale.Am]: 'Պսակ',
        [Locale.En]: 'Crown',
        [Locale.Pt]: 'Coroa',
        [Locale.Ge]: 'Crown',
    },
    crownPart: {
        [Locale.Ru]: 'Коронковая часть',
        [Locale.Am]: 'Պսակային մաս',
        [Locale.En]: 'Crown',
        [Locale.Pt]: 'Coroa',
        [Locale.Ge]: 'გვირგვინის ნაწილი',
    },
    chip: {
        [Locale.Ru]: 'Скол',
        [Locale.Am]: 'Կտրվածք',
        [Locale.En]: 'Chip',
        [Locale.Pt]: 'Lascamento',
        [Locale.Ge]: 'Chip',
    },
    crack: {
        [Locale.Ru]: 'Трещина',
        [Locale.Am]: 'Ճաք',
        [Locale.En]: 'Crack',
        [Locale.Pt]: 'Fissura',
        [Locale.Ge]: 'Crack',
    },
    fracture: {
        [Locale.Ru]: 'Перелом',
        [Locale.Am]: 'Կոտրվածք',
        [Locale.En]: 'Fracture',
        [Locale.Pt]: 'Fratura',
        [Locale.Ge]: 'Fracture',
    },
    resorption: {
        [Locale.Ru]: 'Резорбция',
        [Locale.Am]: 'Ռեզորբցիա',
        [Locale.En]: 'Resorption',
        [Locale.Pt]: 'Resorção',
        [Locale.Ge]: 'Resorption',
    },
    crackFracture: {
        [Locale.Ru]: 'Трещина / Перелом',
        [Locale.Am]: 'Ճաք / Կոտրվածք',
        [Locale.En]: 'Crack / Fracture',
        [Locale.Pt]: 'Fissura / Fratura',
        [Locale.Ge]: 'Crack / Fracture',
    },
    hypoplasiaFluorosis: {
        [Locale.Ru]: 'Гипоплазия / Флюороз',
        [Locale.Am]: 'Հիպոպլազիա / Ֆլյուորոզ',
        [Locale.En]: 'Hypoplasia / Fluorosis',
        [Locale.Pt]: 'Hipoplasia / Fluorose',
        [Locale.Ge]: 'Hypoplasia / Fluorosis',
    },
    colorChange: {
        [Locale.Ru]: 'Изменение цвета без подтверждённой патологии',
        [Locale.Am]: 'Գույնի փոփոխություն՝ առանց հաստատված ախտաբանության',
        [Locale.En]: 'Color change without confirmed pathology',
        [Locale.Pt]: 'Alteração de cor sem patologia confirmada',
        [Locale.Ge]: 'Color change without confirmed pathology',
    },
    postAndCore: {
        [Locale.Ru]: 'Культевая вкладка',
        [Locale.Am]: 'Կոճղարմատային ներդիր',
        [Locale.En]: 'Post-and-core',
        [Locale.Pt]: 'Núcleo com pino',
        [Locale.Ge]: 'Post-and-core',
    },
    sealedFissures: {
        [Locale.Ru]: 'Герметизированные фиссуры',
        [Locale.Am]: 'Հերմետիկացված ճեղքեր',
        [Locale.En]: 'Sealed fissures',
        [Locale.Pt]: 'Fissuras seladas',
        [Locale.Ge]: 'Sealed fissures',
    },
    healthy: {
        [Locale.Ru]: 'Без дефекта',
        [Locale.Am]: 'Առանց դեֆեկտի',
        [Locale.En]: 'Defect-free',
        [Locale.Pt]: 'Sem defeito',
        [Locale.Ge]: 'Defect-free',
    },
    defective: {
        [Locale.Ru]: 'С дефектом',
        [Locale.Am]: 'Դեֆեկտով',
        [Locale.En]: 'Defective',
        [Locale.Pt]: 'Com defeito',
        [Locale.Ge]: 'Defective',
    },
    temporary: {
        [Locale.Ru]: 'Временная',
        [Locale.Am]: 'Ժամանակավոր',
        [Locale.En]: 'Temporary',
        [Locale.Pt]: 'Provisória',
        [Locale.Ge]: 'Temporary',
    },
    temporaryCrown: {
        [Locale.Ru]: 'Временная коронка',
        [Locale.Am]: 'Ժամանակավոր պսակ',
        [Locale.En]: 'Temporary crown',
        [Locale.Pt]: 'Coroa provisória',
        [Locale.Ge]: 'Temporary crown',
    },
    defectFreeCrown: {
        [Locale.Ru]: 'Коронка без дефекта',
        [Locale.Am]: 'Պսակ առանց դեֆեկտի',
        [Locale.En]: 'Defect-free crown',
        [Locale.Pt]: 'Coroa sem defeito',
        [Locale.Ge]: 'Defect-free crown',
    },
    defectiveCrown: {
        [Locale.Ru]: 'Коронка с дефектом',
        [Locale.Am]: 'Պսակ դեֆեկտով',
        [Locale.En]: 'Defective crown',
        [Locale.Pt]: 'Coroa com defeito',
        [Locale.Ge]: 'Defective crown',
    },
    veneer: {
        [Locale.Ru]: 'Винир',
        [Locale.Am]: 'Վինիր',
        [Locale.En]: 'Veneer',
        [Locale.Pt]: 'Faceta',
        [Locale.Ge]: 'Veneer',
    },
    defectFreeVeneer: {
        [Locale.Ru]: 'Винир без дефекта',
        [Locale.Am]: 'Վինիր առանց դեֆեկտի',
        [Locale.En]: 'Veneer defect-free',
        [Locale.Pt]: 'Veneer sem defeito',
        [Locale.Ge]: 'Veneer defect-free',
    },
    defectiveVeneer: {
        [Locale.Ru]: 'Винир с дефектом',
        [Locale.Am]: 'Վինիր դեֆեկտով',
        [Locale.En]: 'Defective veneer',
        [Locale.Pt]: 'Faceta com defeito',
        [Locale.Ge]: 'Defective veneer',
    },
    inlayOnlay: {
        [Locale.Ru]: 'Вкладка / Накладка',
        [Locale.Am]: 'Ներդիր / Վերադիր',
        [Locale.En]: 'Inlay / Onlay',
        [Locale.Pt]: 'Inlay / Onlay',
        [Locale.Ge]: 'Inlay / Onlay',
    },
    defectFreeInlay: {
        [Locale.Ru]: 'Вкладка без дефекта',
        [Locale.Am]: 'Ներդիր առանց դեֆեկտի',
        [Locale.En]: 'Inlay defect-free',
        [Locale.Pt]: 'Inlay sem defeito',
        [Locale.Ge]: 'Inlay defect-free',
    },
    defectiveInlay: {
        [Locale.Ru]: 'Вкладка с дефектом',
        [Locale.Am]: 'Ներդիր դեֆեկտով',
        [Locale.En]: 'Defective inlay',
        [Locale.Pt]: 'Inlay com defeito',
        [Locale.Ge]: 'Defective inlay',
    },
    surface: {
        [Locale.Ru]: 'Поверхность',
        [Locale.Am]: 'Մակերես',
        [Locale.En]: 'Surface',
        [Locale.Pt]: 'Superfície',
        [Locale.Ge]: 'Surface',
    },
    surfaceShort: {
        [Locale.Ru]: 'пов-ть',
        [Locale.Am]: 'մակ-ս',
        [Locale.En]: 'Surface',
        [Locale.Pt]: 'Superfície',
        [Locale.Ge]: 'Surface',
    },
    caries: {
        [Locale.Ru]: 'Кариес',
        [Locale.Am]: 'Կարիես',
        [Locale.En]: 'Caries',
        [Locale.Pt]: 'Cárie',
        [Locale.Ge]: 'Caries',
    },
    defectiveFilling: {
        [Locale.Ru]: 'Дефект пломбы',
        [Locale.Am]: 'Պլոմբի դեֆեկտ',
        [Locale.En]: 'Defective filling',
        [Locale.Pt]: 'Restauração defeituosa',
        [Locale.Ge]: 'Defective filling',
    },
    erosion: {
        [Locale.Ru]: 'Эрозия',
        [Locale.Am]: 'Էրոզիա',
        [Locale.En]: 'Erosion',
        [Locale.Pt]: 'Erosão',
        [Locale.Ge]: 'Erosion',
    },
    wedgeDefect: {
        [Locale.Ru]: 'Клиновидный дефект',
        [Locale.Am]: 'Սեպաձև դեֆեկտ',
        [Locale.En]: 'Wedge-shaped defect',
        [Locale.Pt]: 'Defeito em cunha',
        [Locale.Ge]: 'Wedge-shaped defect',
    },
    pigmentation: {
        [Locale.Ru]: 'Пигментация',
        [Locale.Am]: 'Պիգմենտացիա',
        [Locale.En]: 'Pigmentation',
        [Locale.Pt]: 'Pigmentação',
        [Locale.Ge]: 'Pigmentation',
    },
    filling: {
        [Locale.Ru]: 'Пломба',
        [Locale.Am]: 'Պլոմբ',
        [Locale.En]: 'Filling',
        [Locale.Pt]: 'Obturação',
        [Locale.Ge]: 'Filling',
    },
    bridge: {
        [Locale.Ru]: 'Мост (промежуточная часть)',
        [Locale.Am]: 'Կամուրջ (միջանկյալ մաս)',
        [Locale.En]: 'Bridge (pontic)',
        [Locale.Pt]: 'Ponte (pôntico)',
        [Locale.Ge]: 'Bridge (pontic)',
    },
    fillingCaries: {
        [Locale.Ru]: 'Пломба / Кариес',
        [Locale.Am]: 'Պլոմբ / Կարիես',
        [Locale.En]: 'Filling / Caries',
        [Locale.Pt]: 'Obturação / Cárie',
        [Locale.Ge]: 'Filling / Caries',
    },
    overhangingMargin: {
        [Locale.Ru]: 'Нависающий край пломбы',
        [Locale.Am]: 'Պլոմբի կախված եզր',
        [Locale.En]: 'Overhanging filling margin',
        [Locale.Pt]: 'Margem excessiva da restauração',
        [Locale.Ge]: 'Overhanging filling margin',
    },
    implant: {
        [Locale.Ru]: 'Имплант',
        [Locale.Am]: 'Իմպլանտ',
        [Locale.En]: 'Implant',
        [Locale.Pt]: 'Implante',
        [Locale.Ge]: 'Implant',
    },
    implantCrown: {
        [Locale.Ru]: 'Коронка на импланте',
        [Locale.Am]: 'Պսակ իմպլանտի վրա',
        [Locale.En]: 'Implant-supported crown',
        [Locale.Pt]: 'Coroa sobre implante',
        [Locale.Ge]: 'Implant-supported crown',
    },
    defectFreeImplantCrown: {
        [Locale.Ru]: 'Коронка на импланте без дефекта',
        [Locale.Am]: 'Պսակ իմպլանտի վրա՝ առանց դեֆեկտի',
        [Locale.En]: 'Defect-free implant crown',
        [Locale.Pt]: 'Coroa sobre implante com defeito',
        [Locale.Ge]: 'Defect-free implant crown',
    },
    defectiveImplantCrown: {
        [Locale.Ru]: 'Коронка на импланте с дефектом',
        [Locale.Am]: 'Պսակ իմպլանտի վրա՝ դեֆեկտով',
        [Locale.En]: 'Defective implant crown',
        [Locale.Pt]: 'Coroa sobre implante com defeito',
        [Locale.Ge]: 'Defective implant crown',
    },
    periImplantitis: {
        [Locale.Ru]: 'Переимплантит',
        [Locale.Am]: 'Պերիիմպլանտիտ',
        [Locale.En]: 'Peri-implantitis',
        [Locale.Pt]: 'Peri-implantite',
        [Locale.Ge]: 'Peri-implantitis',
    },
    root: {
        [Locale.Ru]: 'Корень',
        [Locale.Am]: 'Արմատ',
        [Locale.En]: 'Root',
        [Locale.Pt]: 'Raiz',
        [Locale.Ge]: 'Root',
    },
    missing: {
        [Locale.Ru]: 'Отсутствует',
        [Locale.Am]: 'Բացակայում է',
        [Locale.En]: 'Missing',
        [Locale.Pt]: 'Falta',
        [Locale.Ge]: 'Missing',
    },
    rootMissing: {
        [Locale.Ru]: 'Отсутствует корень',
        [Locale.Am]: 'Արմատը բացակայում է',
        [Locale.En]: 'Root missing',
        [Locale.Pt]: 'Falta de raiz',
        [Locale.Ge]: 'Root missing',
    },
    rootPerforation: {
        [Locale.Ru]: 'Перфорация корня',
        [Locale.Am]: 'Արմատի պերֆորացիա',
        [Locale.En]: 'Root perforation',
        [Locale.Pt]: 'Perfuração radicular',
        [Locale.Ge]: 'Root perforation',
    },
    perforation: {
        [Locale.Ru]: 'Перфорация',
        [Locale.Am]: 'Պերֆորացիա',
        [Locale.En]: 'Perforation',
        [Locale.Pt]: 'Perfuração radicular',
        [Locale.Ge]: 'Perforation',
    },
    canalCalcification: {
        [Locale.Ru]: 'Склероз / Кальцификация канала',
        [Locale.Am]: 'Խողովակի սկլերոզ / կալցիֆիկացիա',
        [Locale.En]: 'Canal calcification',
        [Locale.Pt]: 'Calcificação do canal',
        [Locale.Ge]: 'Canal calcification',
    },
    pulpitis: {
        [Locale.Ru]: 'Пульпит',
        [Locale.Am]: 'Պուլպիտ',
        [Locale.En]: 'Pulpitis',
        [Locale.Pt]: 'Pulpite',
        [Locale.Ge]: 'Pulpitis',
    },
    widenedPeriodontalLigamentSpace: {
        [Locale.Ru]: 'Расширение периодонтальной щели',
        [Locale.Am]: 'Պերիոդոնտալ ճեղքի լայնացում',
        [Locale.En]: 'Widened periodontal ligament space',
        [Locale.Pt]: 'Alargamento do espaço do ligamento periodontal',
        [Locale.Ge]: 'Widened periodontal ligament space',
    },
    periodontitis: {
        [Locale.Ru]: 'Периодонтит',
        [Locale.Am]: 'Պերիոդոնտիտ',
        [Locale.En]: 'Apical periodontitis',
        [Locale.Pt]: 'Periodontite apical',
        [Locale.Ge]: 'Apical periodontitis',
    },
    inlayPeriodontitis: {
        [Locale.Ru]: 'Вкладка/периодонтит',
        [Locale.Am]: 'Ներդիր/պերիոդոնտիտ',
        [Locale.En]: 'Inlay/periodontitis',
        [Locale.Pt]: 'Restauração inlay/periodontite',
        [Locale.Ge]: 'ინლეი/პერიოდონტიტი',
    },
    periodontitisSecond: {
        [Locale.Ru]: 'Пародонтит',
        [Locale.Am]: 'Պարոդոնտիտ',
        [Locale.En]: 'Periodontitis',
        [Locale.Pt]: 'Periodontite',
        [Locale.Ge]: 'Periodontitis',
    },
    gingivitis: {
        [Locale.Ru]: 'Гингивит',
        [Locale.Am]: 'Գինգիվիտ',
        [Locale.En]: 'Gingivitis',
        [Locale.Pt]: 'Gengivite',
        [Locale.Ge]: 'Gingivitis',
    },
    dentalCalculus: {
        [Locale.Ru]: 'Зубной камень',
        [Locale.Am]: 'Ատամնաքար',
        [Locale.En]: 'Dental calculus',
        [Locale.Pt]: 'Tártaro dentário',
        [Locale.Ge]: 'Dental calculus',
    },
    recession: {
        [Locale.Ru]: 'Рецессия',
        [Locale.Am]: 'Ռեցեսիա',
        [Locale.En]: 'Recession',
        [Locale.Pt]: 'Recessão',
        [Locale.Ge]: 'Recession',
    },
    withoutPathology: {
        [Locale.Ru]: 'Без патологий',
        [Locale.Am]: 'Առանց ախտաբանության',
        [Locale.En]: 'Without pathology',
        [Locale.Pt]: 'Sem patologia',
        [Locale.Ge]: 'Without pathology',
    },
    impactedEctopic: {
        [Locale.Ru]: 'Ретинированный / Дистопированный',
        [Locale.Am]: 'Ռետինացված / Դիստոպացված',
        [Locale.En]: 'Impacted / Ectopic',
        [Locale.Pt]: 'Incluso / Ectópico',
        [Locale.Ge]: 'Impacted / Ectopic',
    },
    impactedEctopicWithSymptoms: {
        [Locale.Ru]: 'Ретинированный / Дистопированный с симптомами',
        [Locale.Am]: 'Ռետինացված / Դիստոպացված՝ ախտանշաններով',
        [Locale.En]: 'Impacted / Ectopic with symptoms',
        [Locale.Pt]: 'Incluso / Ectópico com sintomas',
        [Locale.Ge]: 'Impacted / Ectopic with symptoms',
    },
    withSymptoms: {
        [Locale.Ru]: 'С симптомами',
        [Locale.Am]: 'Ախտանշաններով',
        [Locale.En]: 'With symptoms',
        [Locale.Pt]: 'Com sintomas',
        [Locale.Ge]: 'With symptoms',
    },
    impactedEctopicWithoutSymptoms: {
        [Locale.Ru]: 'Ретинированный / Дистопированный без симптомов',
        [Locale.Am]: 'Ռետինացված / Դիստոպացված՝ առանց ախտանշանների',
        [Locale.En]: 'Impacted / Ectopic without symptoms',
        [Locale.Pt]: 'Incluso / Ectópico sem sintomas',
        [Locale.Ge]: 'Impacted / Ectopic without symptoms',
    },
    withoutSymptoms: {
        [Locale.Ru]: 'Без симптомов',
        [Locale.Am]: 'Առանց ախտանշանների',
        [Locale.En]: 'Without symptoms',
        [Locale.Pt]: 'Com complicações',
        [Locale.Ge]: 'Without symptoms',
    },
    devitalized: {
        [Locale.Ru]: 'Депульпированный',
        [Locale.Am]: 'Դեպուլպացված',
        [Locale.En]: 'Devitalized',
        [Locale.Pt]: 'Desvitalizado',
        [Locale.Ge]: 'Devitalized',
    },
    devitalizedWithComplications: {
        [Locale.Ru]: 'Депульпированный с осложнениями',
        [Locale.Am]: 'Դեպուլպացված՝ բարդություններով',
        [Locale.En]: 'Devitalized with complications',
        [Locale.Pt]: 'Desvitalizado com complicações',
        [Locale.Ge]: 'Devitalized with complications',
    },
    withComplications: {
        [Locale.Ru]: 'С осложнениями',
        [Locale.Am]: 'Բարդություններով',
        [Locale.En]: 'With complications',
        [Locale.Pt]: 'Com complicações',
        [Locale.Ge]: 'With complications',
    },
    devitalizedWithoutComplications: {
        [Locale.Ru]: 'Депульпированный без осложнений',
        [Locale.Am]: 'Դեպուլպացված՝ առանց բարդությունների',
        [Locale.En]: 'Devitalized without complications',
        [Locale.Pt]: 'Desvitalizado sem complicações',
        [Locale.Ge]: 'Devitalized without complications',
    },
    withoutComplications: {
        [Locale.Ru]: 'Без осложнений',
        [Locale.Am]: 'Առանց բարդությունների',
        [Locale.En]: 'Without complications',
        [Locale.Pt]: 'Sem complicações',
        [Locale.Ge]: 'Without complications',
    },
    wholeTooth: {
        [Locale.Ru]: 'Зуб целиком',
        [Locale.Am]: 'Ամբողջ ատամ',
        [Locale.En]: 'Whole tooth',
        [Locale.Pt]: 'Dente inteiro',
        [Locale.Ge]: 'Whole tooth',
    },
    ectopic: {
        [Locale.Ru]: 'Дистопия',
        [Locale.Am]: 'Դիստոպիա',
        [Locale.En]: 'Ectopic',
        [Locale.Pt]: 'Distopia',
        [Locale.Ge]: 'Ectopic',
    },
    impacted: {
        [Locale.Ru]: 'Ретенция',
        [Locale.Am]: 'Ռետենցիա',
        [Locale.En]: 'Impacted',
        [Locale.Pt]: 'Impactado',
        [Locale.Ge]: 'Impacted',
    },
    intactTooth: {
        [Locale.Ru]: 'Интактный зуб',
        [Locale.Am]: 'Ինտակտ ատամ',
        [Locale.En]: 'Intact tooth',
        [Locale.Pt]: 'Dente íntegro',
        [Locale.Ge]: 'ინტაქტური კბილი',
    },
    jaw: {
        [Locale.Ru]: 'Челюсть',
        [Locale.Am]: 'Ծնոտ',
        [Locale.En]: 'Jaw',
        [Locale.Pt]: 'Mandíbula',
        [Locale.Ge]: 'Jaw',
    },
    gum: {
        [Locale.Ru]: 'Десна',
        [Locale.Am]: 'Լնդեր',
        [Locale.En]: 'Gum',
        [Locale.Pt]: 'Gengiva',
        [Locale.Ge]: 'Gum',
    },
    upperGum: {
        [Locale.Ru]: 'Верхняя десна',
        [Locale.Am]: 'Վերին լնդեր',
        [Locale.En]: 'Upper gum',
        [Locale.Pt]: 'Gengiva superior',
        [Locale.Ge]: 'Upper gum',
    },
    lowerGum: {
        [Locale.Ru]: 'Нижняя десна',
        [Locale.Am]: 'Ստորին լնդեր',
        [Locale.En]: 'Lower gum',
        [Locale.Pt]: 'Gengiva inferior',
        [Locale.Ge]: 'Lower gum',
    },
    buccal: {
        [Locale.Ru]: 'Вестибулярная',
        [Locale.Am]: 'Վեստիբուլյար',
        [Locale.En]: 'Buccal / Labial',
        [Locale.Pt]: 'Vestibular / Labial',
        [Locale.Ge]: 'Buccal / Labial',
    },
    mesial: {
        [Locale.Ru]: 'Медиальная',
        [Locale.Am]: 'Մեդիալ',
        [Locale.En]: 'Mesial',
        [Locale.Pt]: 'Mesial',
        [Locale.Ge]: 'Mesial',
    },
    palatal: {
        [Locale.Ru]: 'Оральная',
        [Locale.Am]: 'Օրալ',
        [Locale.En]: 'Palatal / Lingual',
        [Locale.Pt]: 'Palatina / Lingual',
        [Locale.Ge]: 'Palatal / Lingual',
    },
    distal: {
        [Locale.Ru]: 'Дистальная',
        [Locale.Am]: 'Դիստալ',
        [Locale.En]: 'Distal',
        [Locale.Pt]: 'Distal',
        [Locale.Ge]: 'Distal',
    },
    occlusal: {
        [Locale.Ru]: 'Окклюзионная',
        [Locale.Am]: 'Օկլյուզիոն',
        [Locale.En]: 'Occlusal',
        [Locale.Pt]: 'Oclusal',
        [Locale.Ge]: 'Occlusal',
    },
};
